// Landing copy (ES/EN) and static data. Claims here come from the products' own
// documentation and from the live sites listed under `portfolio`.

export const CONTACT = {
  email: 'gfong@vlcybernetics.com',
  phone: '+507 68550184',
  phoneHref: 'tel:+50768550184',
  location: 'Panamá',
};

export const PORTFOLIO_SITES = [
  {
    id: 'tocumen',
    name: 'Junta Comunal de Tocumen',
    url: 'https://www.jctocumen.com',
    domain: 'www.jctocumen.com',
    image: '/portfolio/jctocumen.webp',
    accent: '#0B3A6F',
  },
  {
    id: 'romero',
    name: 'BR Romero Espinosa',
    url: 'https://www.brromeroespinosa.com',
    domain: 'www.brromeroespinosa.com',
    image: null,
    accent: '#8A6A12',
  },
  {
    id: 'marianne',
    name: 'Transporte Marianne PTY',
    url: 'https://www.transportemariannepty.com',
    domain: 'www.transportemariannepty.com',
    image: null,
    accent: '#556B2F',
  },
];

export const copy = {
  es: {
    nav: { products: 'Productos', sites: 'Sitios web', why: 'Por qué Valhalla', contact: 'Contacto', login: 'Iniciar sesión', cta: 'Hablemos' },
    hero: {
      eyebrow: 'Software a medida · Panamá',
      titleStart: 'Construimos el software que tu negocio',
      titleAccent: 'necesita para crecer',
      description:
        'Valhalla Corporations diseña plataformas de gestión, sistemas clínicos y sitios web para empresas, clínicas e instituciones. Un solo equipo, de la idea a la operación.',
      primary: 'Ver productos',
      secondary: 'Hablemos de tu proyecto',
      values: ['Legado', 'Innovación', 'Personas', 'Un mañana más sólido'],
      chips: ['Valhalla ERP', 'Lifetide Medical', 'Sitios web a medida'],
    },
    products: {
      eyebrow: 'Nuestros productos',
      title: 'Plataformas propias, construidas para operar en Panamá',
      subtitle: 'Dos sistemas completos que ya resuelven la operación diaria, más desarrollo a la medida cuando tu caso lo pide.',
      erp: {
        tag: 'Gestión empresarial',
        name: 'Valhalla ERP',
        tagline: 'Operación, finanzas y TI en un solo sistema.',
        features: [
          'Facturación con ITBMS y soporte del CUFE de la DGI',
          'Cotizaciones, contabilidad y órdenes de compra sin doble registro',
          'Proyectos, control de horas, empleados y vacaciones',
          'CRM, clientes, proveedores y cuentas por pagar',
          'Operaciones IT: activos, visitas técnicas, tickets y mantenimiento',
          'Reporte de gastos desde el celular escaneando el QR de la factura',
        ],
        cta: 'Acceder al ERP',
      },
      lifetide: {
        tag: 'Salud',
        name: 'Lifetide Medical',
        tagline: 'Plataforma clínica multi-clínica para Panamá.',
        features: [
          'Expediente clínico sobre estándar FHIR R4',
          'Pacientes, citas, recepción, encuentros y recetas',
          'Facturación, cargos y cierres de caja',
          'Hemodiálisis, hospitalización y custodia de medicamentos',
          'Laboratorio (HL7), radiología, farmacia y reclamos a seguros',
          'Portal del paciente, telemedicina y avisos por WhatsApp/SMS',
        ],
        cta: 'Solicitar una demostración',
      },
    },
    sites: {
      eyebrow: 'Sitios web a medida',
      title: 'Sitios que representan a tu marca y trabajan para ti',
      subtitle: 'Diseñamos y desarrollamos sitios institucionales y comerciales. Estos son algunos de los que ya están en línea.',
      visit: 'Visitar sitio',
      items: {
        tocumen: {
          type: 'Portal ciudadano · Gobierno local',
          description: 'Portal institucional con servicios, reporte de problemas de la comunidad, actos de contratación y acceso de usuarios.',
        },
        romero: {
          type: 'Bienes raíces · Inversión',
          description: 'Catálogo de propiedades, inversión de renta dinámica, alquileres, terrenos, blog, testimonios y asesoría de visas de residencia.',
        },
        marianne: {
          type: 'Sitio corporativo · Transporte',
          description: 'Presencia web profesional para una empresa de transporte en Panamá.',
        },
      },
      includesTitle: 'Qué puede incluir tu proyecto',
      includes: [
        'Diseño a medida con tu identidad',
        'Adaptado a celular y tablet',
        'Versión bilingüe cuando la necesitas',
        'Dominio, correo y publicación',
        'Formularios y contacto por WhatsApp',
        'Mantenimiento y soporte continuo',
        'Optimización para buscadores (SEO) y carga rápida',
        'Panel para que administres tu propio contenido',
        'Certificado de seguridad (HTTPS)',
        'Mapas, redes sociales y analítica de visitas',
        'Portales con usuarios y acceso restringido',
        'Integración con Valhalla ERP y otros sistemas',
      ],
    },
    why: {
      eyebrow: 'Por qué Valhalla',
      title: 'Tecnología seria, con trato cercano',
      pillars: [
        { title: 'Hecho para Panamá', text: 'ITBMS, DGI, RUC y español desde el diseño, no como un parche.' },
        { title: 'De la idea a la operación', text: 'Diseño, desarrollo, despliegue y soporte con un mismo equipo responsable.' },
        { title: 'Seguridad y trazabilidad', text: 'Roles, control de acceso y bitácora de auditoría en los sistemas que construimos.' },
        { title: 'Pensado para el celular', text: 'Flujos que se completan desde el teléfono: escanear, reportar y aprobar.' },
      ],
      processTitle: 'Cómo trabajamos',
      process: [
        { title: 'Descubrimiento', text: 'Entendemos tu operación y lo que necesitas resolver.' },
        { title: 'Diseño', text: 'Definimos flujos y una interfaz clara antes de programar.' },
        { title: 'Construcción', text: 'Entregas por etapas que puedes probar y ajustar.' },
        { title: 'Acompañamiento', text: 'Puesta en marcha, capacitación y soporte.' },
      ],
    },
    contact: {
      eyebrow: 'Contacto',
      title: 'Hablemos de tu proyecto',
      subtitle: 'Cuéntanos qué necesitas y te respondemos con una propuesta clara.',
      interestLabel: '¿Qué te interesa?',
      interests: { erp: 'Valhalla ERP', lifetide: 'Lifetide Medical', website: 'Un sitio web', other: 'Otro proyecto' },
      send: 'Escribir por correo',
      phoneLabel: 'Teléfono',
      emailLabel: 'Correo',
      locationLabel: 'Ubicación',
      subjectPrefix: 'Consulta:',
    },
    footer: {
      tagline: 'Construido para un mañana más sólido.',
      rights: 'Todos los derechos reservados.',
      ruc: 'RUC 155781291-2-2026',
      privacyNote: 'Sistemas y sitios web a medida desde Panamá.',
    },
  },
  en: {
    nav: { products: 'Products', sites: 'Websites', why: 'Why Valhalla', contact: 'Contact', login: 'Sign in', cta: "Let's talk" },
    hero: {
      eyebrow: 'Custom software · Panama',
      titleStart: 'We build the software your business',
      titleAccent: 'needs to grow',
      description:
        'Valhalla Corporations designs management platforms, clinical systems and websites for companies, clinics and institutions. One team, from idea to operation.',
      primary: 'See products',
      secondary: "Let's talk about your project",
      values: ['Legacy', 'Innovation', 'People', 'A stronger tomorrow'],
      chips: ['Valhalla ERP', 'Lifetide Medical', 'Custom websites'],
    },
    products: {
      eyebrow: 'Our products',
      title: 'Our own platforms, built to operate in Panama',
      subtitle: 'Two complete systems that already handle day-to-day operations, plus custom development when your case calls for it.',
      erp: {
        tag: 'Business management',
        name: 'Valhalla ERP',
        tagline: 'Operations, finance and IT in one system.',
        features: [
          'Invoicing with ITBMS and DGI CUFE support',
          'Quotes, accounting and purchase orders without double entry',
          'Projects, time tracking, employees and vacations',
          'CRM, clients, suppliers and accounts payable',
          'IT operations: assets, technical visits, tickets and maintenance',
          'Expense reporting from your phone by scanning the invoice QR',
        ],
        cta: 'Open the ERP',
      },
      lifetide: {
        tag: 'Healthcare',
        name: 'Lifetide Medical',
        tagline: 'Multi-clinic clinical platform for Panama.',
        features: [
          'Clinical record on the FHIR R4 standard',
          'Patients, appointments, reception, encounters and prescriptions',
          'Billing, charges and cash closures',
          'Hemodialysis, hospitalization and medication custody',
          'Lab (HL7), radiology, pharmacy and insurance claims',
          'Patient portal, telemedicine and WhatsApp/SMS notices',
        ],
        cta: 'Request a demo',
      },
    },
    sites: {
      eyebrow: 'Custom websites',
      title: 'Websites that represent your brand and work for you',
      subtitle: 'We design and build institutional and commercial websites. Here are some that are already online.',
      visit: 'Visit site',
      items: {
        tocumen: {
          type: 'Citizen portal · Local government',
          description: 'Institutional portal with services, community problem reports, procurement notices and user access.',
        },
        romero: {
          type: 'Real estate · Investment',
          description: 'Property catalog, dynamic-income investment, rentals, land, blog, testimonials and residency visa advice.',
        },
        marianne: {
          type: 'Corporate site · Transport',
          description: 'Professional web presence for a transport company in Panama.',
        },
      },
      includesTitle: 'What your project can include',
      includes: [
        'Custom design with your identity',
        'Works on phones and tablets',
        'Bilingual version when you need it',
        'Domain, email and publishing',
        'Forms and WhatsApp contact',
        'Ongoing maintenance and support',
        'Search engine optimization (SEO) and fast loading',
        'A panel so you can manage your own content',
        'Security certificate (HTTPS)',
        'Maps, social networks and visitor analytics',
        'Portals with users and restricted access',
        'Integration with Valhalla ERP and other systems',
      ],
    },
    why: {
      eyebrow: 'Why Valhalla',
      title: 'Serious technology, close service',
      pillars: [
        { title: 'Made for Panama', text: 'ITBMS, DGI, RUC and Spanish built in from the start, not bolted on.' },
        { title: 'From idea to operation', text: 'Design, development, deployment and support with one accountable team.' },
        { title: 'Security and traceability', text: 'Roles, access control and an audit log in the systems we build.' },
        { title: 'Built for the phone', text: 'Flows you can finish from your phone: scan, report and approve.' },
      ],
      processTitle: 'How we work',
      process: [
        { title: 'Discovery', text: 'We learn your operation and what you need to solve.' },
        { title: 'Design', text: 'We define flows and a clear interface before coding.' },
        { title: 'Build', text: 'Staged deliveries you can test and adjust.' },
        { title: 'Support', text: 'Launch, training and ongoing support.' },
      ],
    },
    contact: {
      eyebrow: 'Contact',
      title: "Let's talk about your project",
      subtitle: 'Tell us what you need and we will reply with a clear proposal.',
      interestLabel: 'What are you interested in?',
      interests: { erp: 'Valhalla ERP', lifetide: 'Lifetide Medical', website: 'A website', other: 'Another project' },
      send: 'Write by email',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      locationLabel: 'Location',
      subjectPrefix: 'Inquiry:',
    },
    footer: {
      tagline: 'Built for a stronger tomorrow.',
      rights: 'All rights reserved.',
      ruc: 'RUC 155781291-2-2026',
      privacyNote: 'Custom systems and websites from Panama.',
    },
  },
};
